import { CircularProgress } from "@mui/material";
import LoaderStyles from "./Loaders.module.scss";
import Typography from "../Typography/Typography";
import { Suspense, SuspenseProps } from "react";

export const Loader = ({
  hideDescription = false,
  loaderText,
  loaderColor = "var(--primaryGreyColor)",
}: any) => {
  return (
    <div className={LoaderStyles.loader}>
      <CircularProgress
        size={20}
        style={{
          color: loaderColor,
        }}
      />
      <Typography
        color="var(--primaryGreyColor)"
        fontSize={14}
        fontStyle="italic"
      >
        Loading...
      </Typography>
      {!hideDescription && <Typography>{loaderText}</Typography>}
    </div>
  );
};

export const LoaderForSuspense = (
  <div className={LoaderStyles.suspenseLoaderContainer}>
    <CircularProgress />
  </div>
);

export const SuspenseLoader = ({
  children,
  fallback = LoaderForSuspense,
}: SuspenseProps) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};
